import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

// vuex
import store from './store'; // 修改为相对路径
Vue.prototype.$store = store

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

Vue.use(VideoPlayer) // 注册全局组件

// 自定义组件
import SuPage from "./components/su-page/su-page";
import SuTitle from "./components/su-title/su-title";
import listItem from "./components/list-item/list-item";
import SuDetails from "./components/su-details/su-details";
// 分页组件
import Pagination from "@/components/Pagination";

//注册全局组件
Vue.component('su-page', SuPage);
Vue.component('su-page', SuPage);
Vue.component('su-title', SuTitle);
Vue.component('list-item', listItem);
Vue.component('su-details', SuDetails);
Vue.component('Pagination', Pagination)

//全局挂载
Vue.prototype.global = SuTitle
Vue.prototype.global = SuPage
Vue.prototype.global = listItem
Vue.prototype.global = SuDetails

import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    //完全显示的时候加载
    preLoad: 1,
    //失败时显示的图片
    error: require('./assets/img/error.png'),
    //加载时显示的GIF图
    loading: require('./assets/img/loading.gif'),
    //尝试加载几次
    attempt: 1
});

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000
//设置api地址
//全局定义axios
axios.defaults.baseURL = 'http://shkjgw.shkjem.com/api/'
Vue.prototype.$http = axios

// 图片服务器地址
Vue.prototype.imgserver = 'http://shkjgw.shkjem.com/'

new Vue({
    store, // 将 store 注入到 Vue 实例中
    router,
    render: h => h(App)
}).$mount('#app')
